import { UPDATE_EDITOR_CONTEXT_STATE } from "state/ui/editorContext/editorContextActionTypes";
import { LOAD_DESIGN } from "state/ui/editor/editorActionTypes";

export const initialState = {
  canvasBackground: null,
  collectionDesignsUpdating: {},
  context: {
    isInTextEditMode: false,
    isTimelineVisible: false
  },
  contextMenu: null,
  currentPageId: null,
  designData: null,
  elementPreviews: {},
  elementsToPlayAudio: {},
  highlightedElementIds: null,
  highlightedSection: null,
  // htmlElements: {},
  isCropping: false,
  isEditTitleModalOpen: false,
  isGuideDragging: false,
  isImMode: false,
  isPlaying: {},
  isPaused: {},
  currentPlayingTime: {},
  isResizing: false,
  isSavingErrorModalOpen: false,
  isShowingRulersAndGuides: false,
  kerningHud: null,
  measurementBreakdown: 100,
  measurementUnits: "px",
  ready: false,
  selectedItems: [],
  showBleed: false,
  snapToCorners: true,
  unitHeight: 0,
  unitWidth: 0,
  zoom: 1,
  useDesignSmartFields: false,
  isSharedDialogOpen: false,
  isDocumentTextMode: false,
  documentTextModeTargetId: null,
  // Page transitions
  isPageViewMode: false,
  activeTransitionEditPageId: null,
  // Design-wide playback
  isDesignPlaybackMode: false, // true when playing full design (vs per-page)
  isDesignPlaybackPaused: false, // true when design playback is paused
  designPlaybackTime: 0, // current time in full design (ms)
  currentPlaybackSegment: null // page: { type:'page', pageId, timeInPage }; transition (overlap): { type:'transition', pageId, nextPageId, progress, outgoingTimeInPage, incomingTimeInPage, transition }
};

const editorContextReducers = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EDITOR_CONTEXT_STATE:
      return {
        ...state,
        ...action.payload
      };
    case LOAD_DESIGN: {
      return {
        ...state,
        designData: action.data,
        selectedItems: [],
        useDesignSmartFields: false,
        isSharedDialogOpen: false,
        isDocumentTextMode: false,
        documentTextModeTargetId: null,
        // Reset so a reopened design with no animations starts with the
        // timeline hidden, even when switching designs in-app.
        isTimelineVisible: false
      };
    }
    default:
      return state;
  }
};

export default editorContextReducers;
